import React from 'react';
import { ChecklistItem, TripMatch } from '@marageti/z4-sdk/lib/travel';
import {
  useApiClient,
  useFetchImmutable,
} from '@marageti/z4-lib';
import { CountryCodeMap } from '@marageti/z4-sdk/lib/standards';
import { useSnackbar } from 'notistack';
import SoldCardView from './sold-card-view';

type SoldCardContainerProps = {
  tripMatch: TripMatch;
  showReturnDate?: boolean;
  onRefreshResults?: () => void;
};

const SoldCardContainer = ({
  tripMatch,
  showReturnDate = false,
  onRefreshResults,
}: SoldCardContainerProps) => {
  const apiClient = useApiClient();
  const { enqueueSnackbar } = useSnackbar();

  const {
    data: countryCodes,
  } = useFetchImmutable<CountryCodeMap>(apiClient.standardsClient.getCountryCodes, [], true);

  const onDismiss = (tripMatchId: string) => {
    Promise.all([
      apiClient.tripMatchesClient.deleteTripMatchChecklistItem(tripMatchId, ChecklistItem.NeedsZicassoReview),
      apiClient.tripMatchesClient.deleteTripMatchChecklistItem(tripMatchId, ChecklistItem.NeedsZicassoReviewRequest),
    ]).then(() => {
      onRefreshResults?.();
      enqueueSnackbar('Trip dismissed.', { variant: 'success' });
    }).catch(() => {
      enqueueSnackbar('Failed to remove checklist item.', { variant: 'default' });
    });
  };

  return (
    <SoldCardView
      countryCodes={countryCodes}
      tripMatch={tripMatch}
      showReturnDate={showReturnDate}
      onDismiss={onDismiss}
    />
  );
};

export default SoldCardContainer;
